/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nodrops1Inputs */

const en_nodrops1 = /** @type {(inputs: Nodrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No drops yet`)
};

const de_nodrops1 = /** @type {(inputs: Nodrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Drops`)
};

/**
* | output |
* | --- |
* | "No drops yet" |
*
* @param {Nodrops1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nodrops1 = /** @type {((inputs?: Nodrops1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nodrops1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nodrops1(inputs)
	return de_nodrops1(inputs)
});
export { nodrops1 as "noDrops" }